import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { starIcon } from '../../icons';

@Component({
    selector: 'app-stars-score',
    template: `
        <span class="stars-score__icon" *ngFor="let slot of scoreArray">${starIcon}</span>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StarsScoreComponent {
    @Input()
    set score(value: number | null | undefined) {
        const safeValue = Number.isFinite(value) && value! > 0 ? Math.floor(value!) : 0;
        this.scoreArray = Array(safeValue).fill(0);
    }
    @HostBinding('class') class = 'stars-score';

    scoreArray: any[];
}
